import type { RouteRecordRaw } from "vue-router";
import { createRouter, createWebHistory } from "vue-router";
import { publicDevelopRoutes } from "./modules/develop";
import { homepageRoutes } from "./modules/homepage";
import { resultRoutes } from "./modules/result";
import { userRoutes } from "./modules/user";
import { envConfig } from "@/shared/config/env";

export const baseRoutes: RouteRecordRaw[] = [
  ...userRoutes,
  ...publicDevelopRoutes,
  ...homepageRoutes,
  ...resultRoutes,
];

const router = createRouter({
  history: createWebHistory(envConfig.baseUrl),
  routes: baseRoutes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export function getActivePath(maxLevel = 3) {
  const route = router.currentRoute.value;

  return route.path
    .split("/")
    .filter((item, index) => item && index <= maxLevel)
    .map((item) => `/${item}`)
    .join("");
}

export default router;
